import React, { useState, useEffect } from 'react';
import './projets.scss';

function Projets() {
  const [cv, setCv] = useState(false);
  const [nasa, setNasa] = useState(false);
  const [avenir, setAvenir] = useState(false)

  const showCv = () => {
    setCv(true);
  };
  const hideCv = () => {
    setCv(false);
  };
  const showNasa = () => {
    setNasa(true);
  };
  const hideNasa = () => {
    setNasa(false);
  };
  const showAvenir = () => {
    setAvenir(true)
  }
  const hideAvenir = () => {
    setAvenir(false)
  }
  // const indexPageURL = './src/projects/nasa_project/app/index.php';
  // const handleClick = () => {
  //   // Ouvrir la page index.php dans une nouvelle fenêtre ou un nouvel onglet
  //   window.open('./src/projects/nasa_project/app/index.php', '_blank');
  // };
  return (
    <section id="projects">
      <h2 className="fs-40">Projets</h2>
      <article>
        <div className="projects">
          <div
            onMouseOver={showCv}
            onMouseLeave={hideCv}
          >
            <h3>CV en ligne</h3>
            <img className="projet" src="./img/cvv.png" alt="" />
          </div>
          <div
            id="nasa"
            onMouseOver={showNasa}
            onMouseLeave={hideNasa}
          >
            <a href="https://philippegenot.com/nasa" id="goNasa" target="_blank" rel="noreferrer" style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}>
              <h3>My NASA Project</h3>
              <img className="projet" src="./img/nasa_pro.png" alt="" />
            </a>
          </div>
        </div>

        {cv && (
          <div id="cv_para">
            <p>Technos et outils utilisés :</p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> HTML
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> REACT
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> SASS
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Git
            </p>
          </div>
        )}

        {nasa && (
          <div id="nasa_para">
            <p>Connexion à une des API de la NASA pour afficher la dernière exoplanète découverte avec le satellite TESS.</p>
            <p>Technos et outils utilisés :</p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> PHP
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Tailwind
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Postman
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Docker
            </p>
            <p className="ul-list">
              <img src="/img/icons/blue-arrow.svg" className="blue-arr" /> Git
            </p>
          </div>
        )}

        <div className="projects2">

          <div id="avenir"
          onMouseOver={showAvenir}
          onMouseLeave={hideAvenir}>
            <h3>En cours</h3>
            <img className="projet" src="./img/icons/Interrogation.svg" alt="" />
          </div>
        </div>
          {avenir &&(
        <div id="avenir_para">
          <p className="ul-list">
            Auto-formation et mise en place d'un projet Java.
          </p>
        </div>
          )
        }
      </article>
    </section>
  );
}

export default Projets;
